var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.74246 2.39907C8.26561 2.16675 8.81132 1.9759 9.37537 1.83072L9.62463 2.79916C9.11471 2.9304 8.62136 3.10294 8.14832 3.31301L7.74246 2.39907ZM2.7554 7.01714C3.30682 5.99612 4.02227 5.0771 4.86634 4.29524L5.5459 5.02886C4.78164 5.7368 4.13411 6.5687 3.63528 7.49234L2.7554 7.01714ZM1.5 11.9999C1.5 11.4137 1.54809 10.8383 1.64065 10.2776L2.6273 10.4405C2.54359 10.9475 2.5 11.4684 2.5 11.9999C2.5 12.5314 2.54359 13.0523 2.6273 13.5593L1.64065 13.7222C1.54809 13.1615 1.5 12.5861 1.5 11.9999ZM4.86633 19.7046C4.02227 18.9227 3.30682 18.0037 2.7554 16.9827L3.63528 16.5075C4.13411 17.4311 4.78163 18.263 5.54589 18.9709L4.86633 19.7046ZM9.37537 22.1691C8.81132 22.0239 8.26561 21.833 7.74246 21.6007L8.14832 20.6868C8.62136 20.8969 9.11471 21.0694 9.62463 21.2006L9.37537 22.1691Z",
    fill: "black",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21.5 12C21.5 6.75329 17.2467 2.5 12 2.5V1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5V21.5C17.2467 21.5 21.5 17.2467 21.5 12Z",
    fill: "black",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearn);
export default __webpack_public_path__ + "static/media/learn.00c01c5c3dee69360f487a6e69fcfa7f.svg";
export { ForwardRef as ReactComponent };